// @flow

import googleServicesApi from '../../network/api/googleServicesApi';
import { store } from '../../network/reduce';
import { SET_MAPS_API_KEY } from './googleServicesReducer';

export const fetchMapsApiKey = (): Function =>
  (dispatch: () => void) =>
    googleServicesApi.fetchMapsApiKey()
      .then(response => response.json())
      .then(response => dispatch(store(SET_MAPS_API_KEY, response.token)))
      .catch(console.error);
